import { createReducer, on } from '@ngrx/store'
import * as FeatureMYDActions from './feature-myd.actions'
import { FeatureMYDState } from './feature-myd.state'

export const initialState: FeatureMYDState = {
   searchResult: undefined,
   isLoading: false,
   isSearchDone: false,
   searchRequest: undefined,
}

export const featureMYDReducer = createReducer(
   initialState,
   on(FeatureMYDActions.searchYourDraft, (state) => ({ ...state, searchResult: undefined, isLoading: true, isSearchDone: true })),
   on(FeatureMYDActions.searchYourDraftSuccess, (state, action) => ({ ...state, searchResult: action.result })),
   on(FeatureMYDActions.searchYourDraftFailure, FeatureMYDActions.searchYourDraftSuccess, (state) => ({ ...state, isLoading: false })),

   on(FeatureMYDActions.setActualOrderYourDraft, (state, action) => ({
      ...state,
      searchRequest: { ...state.searchRequest, paging: { ...state.searchRequest?.paging, field: action.order } },
   })),
   on(FeatureMYDActions.setActualPageYourDraft, (state, action) => ({
      ...state,
      searchRequest: { ...state.searchRequest, paging: { ...state.searchRequest?.paging, pageNumber: action.page } },
   })),
   on(FeatureMYDActions.setSearchRequestYourDraft, (state, action) => ({
      ...state,
      searchRequest: action.request,
   })),
   on(FeatureMYDActions.setItemForPageYourDraft, (state, action) => ({
      ...state,
      searchRequest: { ...state.searchRequest, paging: { ...state.searchRequest?.paging, pageSize: action.itemForPage } },
   })),
   on(FeatureMYDActions.initManageYourDraftSearch, (state) => ({
      ...state,
      searchResult: undefined,
      isLoading: false,
      isSearchDone: false,
      searchRequest: undefined,
   })),
   on(FeatureMYDActions.getNumberOfYourDrafts, (state) => ({
      ...state,
      isLoadingDraftCount: true,
   })),
   on(FeatureMYDActions.getNumberOfYourDraftsSuccess, (state, action) => ({
      ...state,
      draftCount: action.count,
      isLoadingDraftCount: undefined,
   })),
   on(FeatureMYDActions.getNumberOfYourDraftsFailure, (state) => ({
      ...state,
      isLoadingDraftCount: undefined,
   }))
)
